import Backbone from 'backbone';
import utils from 'lib/utils';
/*/ ## EF.program
//
// When an enrollment_id is available, this will return a JSON with: enrollments related school name,
//program name, and an Array of all sponsorships. Primary sponsorship will be flagged true with the
// primary attribute - which can be called directly with getPrimarySponsorship.() All secondary sponsorships
// (if any) will be in an Array via the getSecondarySponsorships() method. */
const Program = Backbone.Model.extend({
  fileName: 'program.json',
  initialize: function (attributes, options) {
    this.enrollment = options.enrollment;
  },
  url: function () {
    return utils.getEnrollmentsUrl(this.enrollment.get('id'), this.fileName);
  },

  sync: function () {
    return utils.backboneSync(this, arguments);
  },

  getPrimrySponsorship: function () {
    const sponsorships = this.get('sponsorships');
    for (let i = 0; i < sponsorships.length; i++) {
      if (sponsorships[i].primary) {
        return sponsorships[i];
      }
    }
  },

  getSecondarySponsorships: function () {
    let matches = 0;
    const sponsorships = this.get('sponsorships');
    const secondary = [];
    for (let i = 0; i < sponsorships.length; i++) {
      if (!sponsorships[i].primary) {
        secondary[matches++] = sponsorships[i];
      }
    }
    return secondary;
  },
});

export default Program;
